<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <form>
    <div class="bg-white rounded-xl p-4 flex items-center gap-4">
      <div class="flex items-center gap-2 w-full">
        <img src="../../assets/image/search.svg" alt="" class="" />
        <input placeholder="Search Concern Type  Here..." class="w-full border p-2 rounded-md outline-none"
          placeholder="Search Material" matInput (keyup)="applyFilter($event)" />
      </div>
      <div *ngIf="false" class="w-80">
        <select style="background: #4d4de6;"
          class="w-full p-2 outline-none bg-gradient-to-r from-primary to-semiPrimary border rounded-md text-white"
          (change)="onStatusChange($event)">
          <option value="">All</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      <div class="w-60">
        <app-primary-button [routerLink]="['/home/add-material']" class="flex w-40">
          <div class="flex space-x-2">
            <img src="../../../../assets/image/+.svg" alt="" />
            <span>{{'ADD_MATERIAL' | translate}}</span>
          </div>
        </app-primary-button>
      </div>
      <div class="w-60">

         <app-primary-button  [routerLink]="['/home/add-excel-import', 'Material']" class="flex w-40">
          <div class="flex space-x-2">
            <img src="../../../../assets/image/+.svg" alt="" />
            <span>{{'IMPORT_MATERIAL' | translate}}</span>
          </div>
        </app-primary-button>
        </div>
    </div>
  </form>

  <!-- Table Section -->
  <div class="bg-white rounded-2xl shadow-md p-4">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z1 w-full text-sm">
      <!-- S.No -->
      <ng-container matColumnDef="srNo">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let row; let i = index">
          {{ i + 1 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="equipment_code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'CODE' | translate}}</th>
        <td mat-cell *matCellDef="let user">{{ user.system_code }}</td>
      </ng-container>

      <ng-container matColumnDef="equipment_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'MATERIAL_NAME' | translate}}</th>
        <td mat-cell *matCellDef="let user">{{ user.name }}</td>
      </ng-container>

      <!-- crewName -->
      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'CATEGORY' | translate}}</th>
        <td mat-cell *matCellDef="let user">{{ user.category }}</td>
      </ng-container>


      <!-- status -->
      <ng-container matColumnDef="is_active">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'STATUS' | translate}}</th>
        <td mat-cell *matCellDef="let user">{{ user.subcategory }}</td>
      </ng-container>

      <!-- action -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>{{'action' | translate}}</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button color="primary" [routerLink]="['/home/edit-material', element.id]">
            <mat-icon>visibility</mat-icon>
          </button>
          <button mat-icon-button color="accent" [routerLink]="['/home/edit-material', element.id]">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Header & Row -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-100 text-gray-700 font-semibold"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="hover:bg-gray-50"></tr>
    </table>

    <app-empty-data *ngIf="dataSource.data.length < 1" class="justify-center align-items-center"
      [imageSource]="'../../assets/blankScreen/support.png'" [message]="'No data available'"></app-empty-data>

    <!-- Paginator -->
    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20,50,100]" showFirstLastButtons class="mt-4"></mat-paginator>
  </div>
</div>

